

export const graphicMobile = [
    {
        id: 1,
        image: "./images/mobile /image-graphic-design.jpg",
        title: "Graphic Design",
        text: "Great design makes you memorable. We deliver artwork that underscores your brand meaasge and captures potential client's attention.",
    },
    {
        id: 2,
        image: './images/mobile /image-photography.jpg',
        title: "Photography",
        text: "Increase your credibility by getting the most stumnning, high-quality photos that improve your business image.",
    },
]


export const graphicDesktop = [
    {
        id: 1,
        image: './images/desktop/image-graphic-design.jpg',
        title: "Graphic Design",
        text: "Great design makes you memorable. We deliver artwork that underscores your brand meaasge and captures potential client's attention.",
    },
    {
        id: 2,
        image: './images/desktop/image-photography.jpg',
        title: "Photography",
        text: "Increase your credibility by getting the most stumnning, high-quality photos that improve your business image.",
    },
]